var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @file 全局加载中
 */
import { Modal } from '../../Modal';
import { LoadingGlobal } from './LoadingGlobal';
export const showGlobalLoading = async (_a) => {
    var _b;
    var { during } = _a, rest = __rest(_a, ["during"]);
    const hasMessage = 'message' in rest;
    const message = hasMessage ? rest.message : undefined;
    const duration = hasMessage ? (_b = rest.duration) !== null && _b !== void 0 ? _b : 3000 : 0;
    const { hide } = Modal.open({
        header: null,
        footer: null,
        width: 320,
        bodyStyle: {
            padding: '0 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        children: _jsx(LoadingGlobal, { message: message }, void 0),
    });
    const timeout = () => new Promise(resolve => setTimeout(resolve, hasMessage ? duration : 0));
    return (Promise.all([during(), timeout()])
        // 有的调用会取 during 的返回值
        .then(([result]) => result)
        .finally(() => hide()));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvU3RhdGUvc2hvd0dsb2JhbExvYWRpbmcvaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztBQUFBOztHQUVHO0FBRUgsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLGFBQWEsQ0FBQTtBQUVuQyxPQUFPLEVBQUUsYUFBYSxFQUFFLE1BQU0saUJBQWlCLENBQUE7QUFnQi9DLE1BQU0sQ0FBQyxNQUFNLGlCQUFpQixHQUFHLEtBQUssRUFBRSxFQUdkLEVBQUUsRUFBRTs7UUFIVSxFQUN0QyxNQUFNLE9BRWtCLEVBRHJCLElBQUksY0FGK0IsVUFHdkMsQ0FEUTtJQUVQLE1BQU0sVUFBVSxHQUFHLFNBQVMsSUFBSSxJQUFJLENBQUE7SUFFcEMsTUFBTSxPQUFPLEdBQUcsVUFBVSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUE7SUFDckQsTUFBTSxRQUFRLEdBQUcsVUFBVSxDQUFDLENBQUMsQ0FBQyxNQUFBLElBQUksQ0FBQyxRQUFRLG1DQUFJLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO0lBRXZELE1BQU0sRUFBRSxJQUFJLEVBQUUsR0FBRyxLQUFLLENBQUMsSUFBSSxDQUFDO1FBQzFCLE1BQU0sRUFBRSxJQUFJO1FBQ1osTUFBTSxFQUFFLElBQUk7UUFDWixLQUFLLEVBQUUsR0FBRztRQUNWLFNBQVMsRUFBRTtZQUNULE9BQU8sRUFBRSxRQUFRO1lBQ2pCLE9BQU8sRUFBRSxNQUFNO1lBQ2YsVUFBVSxFQUFFLFFBQVE7WUFDcEIsY0FBYyxFQUFFLFFBQVE7U0FDekI7UUFDRCxRQUFRLEVBQUUsS0FBQyxhQUFhLElBQUMsT0FBTyxFQUFFLE9BQU8sV0FBSTtLQUM5QyxDQUFDLENBQUE7SUFFRixNQUFNLE9BQU8sR0FBRyxHQUFHLEVBQUUsQ0FDbkIsSUFBSSxPQUFPLENBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQyxVQUFVLENBQUMsT0FBTyxFQUFFLFVBQVUsQ0FBQyxDQUFDLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO0lBRXhFLE9BQU8sQ0FDTCxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUMsTUFBTSxFQUFFLEVBQUUsT0FBTyxFQUFFLENBQUMsQ0FBQztRQUNoQyxxQkFBcUI7U0FDcEIsSUFBSSxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsRUFBRSxFQUFFLENBQUMsTUFBTSxDQUFDO1NBQzFCLE9BQU8sQ0FBQyxHQUFHLEVBQUUsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxDQUN6QixDQUFBO0FBQ0gsQ0FBQyxDQUFBIn0=